/*
 * @Author: lixiaodi
 * @Date: 2020-12-04 10:39:48
 * @LastEditors: lixiaodi
 * @LastEditTime: 2020-12-04 10:39:56
 */
import CryptoJS from "crypto-js";
/**
  *
  * 第一个参数word是待加密或者解密的字符串；
  * 第二个参数keyStr是aes加密需要用到的16位字符串的key；
  * 第三个参数是初始化向量 iv。
  */
export default {
  // 加密
  encrypt(word, keyStr, ivStr) {
    keyStr = keyStr ? keyStr : "tdbSystemManager";
    ivStr = ivStr ? ivStr : "tdbSystemManager";
    let key = CryptoJS.enc.Utf8.parse(keyStr);
    let iv = CryptoJS.enc.Utf8.parse(ivStr);
    let srcs = CryptoJS.enc.Utf8.parse(word);

    let encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.ZeroPadding
    });
    return encrypted.toString();
  },
  // 解密
  decrypt(word, keyStr, ivStr) {
    keyStr = keyStr ? keyStr : "tdbSystemManager";
    ivStr = ivStr ? ivStr : "tdbSystemManager";
    var key = CryptoJS.enc.Utf8.parse(keyStr);
    let iv = CryptoJS.enc.Utf8.parse(ivStr);

    var decrypt = CryptoJS.AES.decrypt(word, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });

    // 处理解码异常
    try {
      return CryptoJS.enc.Utf8.stringify(decrypt);
    } catch (e) {
      // 添加错误处理逻辑
      console.error("Decryption failed", e);
      return null;
    }
  }
};



// WEBPACK FOOTER //
// ./src/untils/CryptoJS.js